import { FC, useState } from 'react';
import {
  VisibilityOutlined as Visibility,
  VisibilityOffOutlined as VisibilityOff,
} from '@mui/icons-material';
import { IconButton, InputAdornment } from '@mui/material';
import { TextField } from '@wellstone-solutions/web';

type PasswordFieldProps = Omit<typeof TextField, 'type'>;

const PasswordField: FC<PasswordFieldProps> = (props) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const handleVisibilityToggle = () => {
    setIsVisible((prev) => !prev);
  };

  return (
    <TextField
      {...props}
      type={isVisible ? 'text' : 'password'}
      InputProps={{
        ...props.InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              tabIndex={-1}
              aria-label={isVisible ? 'Hide password' : 'Show password'}
              onClick={handleVisibilityToggle}
              edge="end">
              {isVisible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export { PasswordField };
